import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
} from "@mui/material";
import { useAuth } from "../contexts/AuthContext";

const ListReservations = () => {
  const getApiBaseUrl = () => {
    // Always use production backend (onrender)
    return import.meta.env.VITE_ENVPROD || 'https://activitynavigator-backend.onrender.com';
  };
  const apiBaseUrl = getApiBaseUrl();
  const [reservations, setReservations] = useState([]);
  const { authToken } = useAuth();

  const fetchReservations = async () => {
    try {
      const response = await axios.get(`${apiBaseUrl}/api/reservations`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.status === 200) {
        setReservations(response.data);
      } else {
        console.error("Error fetching reservations:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching reservations:", error.message);
    }
  };

  useEffect(() => {
    fetchReservations();
  }, [authToken]);

  return (
    <Box sx={{ px: 5, pt: 2 }}>
      <Typography variant="h4">Reservations</Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Reservation ID</TableCell>
              <TableCell>Place ID</TableCell>
              <TableCell>User ID</TableCell>
              <TableCell>Date Booked</TableCell>
              <TableCell>Start Time</TableCell>
              <TableCell>Duration</TableCell>
              <TableCell>Visitors</TableCell>
              <TableCell>Note</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reservations.map((reservation) => (
              <TableRow key={reservation._id}>
                <TableCell>{reservation._id}</TableCell>
                <TableCell>{reservation.placeId}</TableCell>
                <TableCell>{reservation.userId}</TableCell>
                <TableCell>
                  {new Date(reservation.date_booked).toLocaleDateString()}
                </TableCell>
                <TableCell>{reservation.start_time}</TableCell>
                <TableCell>{reservation.duration}</TableCell>
                <TableCell>{reservation.visitors}</TableCell>
                <TableCell>{reservation.note}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ListReservations;
